module.exports = __webpack_public_path__ + "img/location.2826112f.svg";